/** Typed wrapper around Yandex Metrika `ym()` global. */

declare global {
  interface Window {
    ym?: (counterId: number, action: string, ...args: unknown[]) => void;
  }
}

const COUNTER = 109481486;

function ym(action: string, ...args: unknown[]): void {
  window.ym?.(COUNTER, action, ...args);
}

// ── events ────────────────────────────────────────────────────────────────────

export const analytics = {
  /** Пользователь нажал «Войти через Instagram» */
  loginClick: () => ym("reachGoal", "login_click"),

  /** OAuth-авторизация завершилась успехом */
  loginSuccess: (method: string) => ym("reachGoal", "login_success", { method }),

  /** Ошибка при запуске OAuth */
  loginError: () => ym("reachGoal", "login_error"),

  /** Пользователь вышел из аккаунта */
  logout: () => ym("reachGoal", "logout"),

  /** Собственный отчёт загружен */
  reportViewed: () => ym("reachGoal", "report_viewed"),

  /** Публичный отчёт открыт */
  publicReportViewed: (username: string) =>
    ym("reachGoal", "public_report_viewed", { username }),

  /** Нажата кнопка «Обновить» в отчёте */
  reportRefreshed: () => ym("reachGoal", "report_refreshed"),

  /** PDF успешно сохранён */
  reportPdfDownloaded: () => ym("reachGoal", "report_pdf_downloaded"),

  /** Каталог блогеров загружен */
  catalogViewed: (page: number) => ym("reachGoal", "catalog_viewed", { page }),

  /** Клик по карточке блогера в каталоге */
  catalogCardClicked: (username: string) =>
    ym("reachGoal", "catalog_card_clicked", { username }),
};
